import { GroupedIcon } from '@/assets/icons/info-icons/groupedIcon';
import { PlusIcon } from '@/assets/icons/info-icons/plusIcon';
import { useState } from 'react';
import styled from 'styled-components';
import { themeVar } from '@/styles/theme';
import { AssetClassForecastSummaryDto } from '../../types';

interface AssetClassRowProps {
  assetClass: AssetClassForecastSummaryDto;
  targetSubAssetClasses: boolean;
}

export const AssetClassRow = ({ assetClass, targetSubAssetClasses }: AssetClassRowProps) => {
  const [showSubAssetClass, setShowSubAssetClass] = useState(false);

  return (
    <>
      <SimpleTableRow>
        <RowItem width={'32%'}>
          {targetSubAssetClasses && assetClass.subAssetClassForecasts ? (
            <PlusIconWrapper onClick={() => setShowSubAssetClass(!showSubAssetClass)}>
              <PlusIcon fill={themeVar('font.base')} />
            </PlusIconWrapper>
          ) : (
            <></>
          )}
          {assetClass.name}
        </RowItem>
        <RowItem width={'17%'} isBold={Boolean(assetClass.subAssetClassForecasts)}>
          {assetClass.target?.toFixed(2)}%
        </RowItem>
        <RowItem width={'17%'} isBold={Boolean(assetClass.subAssetClassForecasts)}>
          {assetClass.asOfForecast?.toFixed(2)}%
        </RowItem>
        <RowItem width={'17%'} isBold={Boolean(assetClass.subAssetClassForecasts)}>
          {assetClass.fiveYearForecast?.toFixed(2)}%
        </RowItem>
        <RowItem width={'17%'} isBold={Boolean(assetClass.subAssetClassForecasts)}>
          {assetClass.tenYearForecast?.toFixed(2)}%
        </RowItem>
      </SimpleTableRow>
      {showSubAssetClass && (
        <>
          {assetClass.subAssetClassForecasts.map((subAssetClassForecast) => (
            <SimpleTableRow key={subAssetClassForecast.name + subAssetClassForecast.target}>
              <RowItem width={'32%'}>
                <GroupIconWrapper>
                  <GroupedIcon width={10} height={10} />
                </GroupIconWrapper>
                {subAssetClassForecast.name}
              </RowItem>
              <RowItem width={'17%'}>{subAssetClassForecast.target?.toFixed(2)}%</RowItem>
              <RowItem width={'17%'}>{subAssetClassForecast.asOfForecast?.toFixed(2)}%</RowItem>
              <RowItem width={'17%'}>{subAssetClassForecast.fiveYearForecast?.toFixed(2)}%</RowItem>
              <RowItem width={'17%'}>{subAssetClassForecast.tenYearForecast?.toFixed(2)}%</RowItem>
            </SimpleTableRow>
          ))}
        </>
      )}
    </>
  );
};

const RowItem = styled.div<{ width: string; isBold?: boolean }>`
  width: ${({ width }) => width};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  font-family: Blinker, serif;
  font-size: 16px;
  font-weight: ${({ isBold }) => (isBold ? 600 : 400)};
  line-height: 22px;
  letter-spacing: 0;
  color: ${themeVar('font.base')};
`;

const PlusIconWrapper = styled.div`
  padding: 5px;
  cursor: pointer;
`;

const GroupIconWrapper = styled.div`
  padding: 5px;
  position: relative;
  top: -5px;
  left: 5px;
`;

const SimpleTableRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  background-color: ${themeVar('layer.1')};
  margin-bottom: 3px;
  justify-content: space-between;
  border-radius: 4px;
  padding: 5px 24px;
  position: relative;
`;
